import React, { FC, useEffect, useState } from 'react'
import { useFormikContext } from 'formik'
import { formatDateStrShort } from '../../../helpers/FormatDate'
import { getSuggestions } from '../../../services/suggestionService'

type Props = {
  onNextStep: () => void
}

export const SectionPartnerSuggestions: FC<Props> = ({ onNextStep }) => {
  const formik = useFormikContext<any>()
  const [loading, setLoading] = useState(true)
  const [suggestions, setSuggestions] = useState<any[]>([])

  useEffect(() => {
    setLoading(true)
    getSuggestions({ limit: 50 })
      .then((res) => {
        if (res?.results) {
          setSuggestions(res.results)
        } else if (Array.isArray(res)) {
          setSuggestions(res)
        }
      })
      .catch(() => setSuggestions([]))
      .finally(() => setLoading(false))
  }, [])

  const handleSelectSuggestion = async (suggestion: any) => {
    formik.setFieldValue('suggest_id', suggestion.id)
    if (!formik.values.title && suggestion.title) {
      formik.setFieldValue('title', suggestion.title)
    }
    if (!formik.values.description && suggestion.description) {
      formik.setFieldValue('description', suggestion.description)
    }
    await onNextStep()
  }

  if (loading) {
    return (
      <div className='text-center py-10'>
        <span className='spinner-border spinner-border-sm align-middle me-2' /> Loading suggestions...
      </div>
    )
  }

  if (!suggestions || suggestions.length === 0) {
    return <div className='text-center py-10 text-muted'>No suggestions available to create.</div>
  }

  return (
    <div className='admin-experience-page-table w-100 d-flex mt-4'>
      {/* ID Column */}
      <div className='admin-experience-page-table__column admin-experience-page-table__column--80'>
        <div className='admin-experience-page-table__header'>ID</div>
        {suggestions.map((u, index) => (
          <div
            key={`sug-id-${u.id || index}`}
            className='admin-experience-page-table__cell admin-experience-page-table__cell--bold'
          >
            #{u.id}
          </div>
        ))}
      </div>

      {/* Name Column */}
      <div className='admin-experience-page-table__column admin-experience-page-table__column--200'>
        <div className='admin-experience-page-table__header'>TITLE</div>
        {suggestions.map((u, index) => (
          <div
            key={`sug-title-${u.id || index}`}
            className='admin-experience-page-table__cell admin-experience-page-table__cell--bold text-truncate'
            title={u.title}
          >
            {u.title || '—'}
          </div>
        ))}
      </div>

      {/* Submitted By Column */}
      <div className='admin-experience-page-table__column admin-experience-page-table__column--150'>
        <div className='admin-experience-page-table__header'>SUBMITTED BY</div>
        {suggestions.map((u, index) => {
          const submitterName = u.submittedBy?.name || u.submittedBy?.email || 'NOBILIS'
          return (
            <div
              key={`sug-submitter-${u.id || index}`}
              className='admin-experience-page-table__cell admin-experience-page-table__cell--bold'
            >
              <div className='experience-preview-invited-item'>
                {u.submittedBy?.image ? (
                  <img src={u.submittedBy.image} alt='' />
                ) : (
                  <div className='w-20px h-20px rounded-circle bg-secondary text-dark d-flex align-items-center justify-content-center me-2 fs-9 fw-bold'>
                    {submitterName.charAt(0).toUpperCase()}
                  </div>
                )}
                <div className='text-dark admin-experience-page-table__cell--bold text-truncate'>
                  {submitterName}
                </div>
              </div>
            </div>
          )
        })}
      </div>

      {/* Date Column */}
      <div className='admin-experience-page-table__column admin-experience-page-table__column--150'>
        <div className='admin-experience-page-table__header'>DATE</div>
        {suggestions.map((u, index) => (
          <div
            key={`sug-date-${u.id || index}`}
            className='admin-experience-page-table__cell admin-experience-page-table__cell--bold'
          >
            {u.createdAt ? formatDateStrShort(u.createdAt) : '—'}
          </div>
        ))}
      </div>

      {/* Actions Column */}
      <div className='admin-experience-page-table__column admin-experience-page-table__column--120'>
        <div className='admin-experience-page-table__header'>ACTION</div>
        {suggestions.map((u, index) => (
          <div key={`sug-action-${u.id || index}`} className='admin-experience-page-table__cell'>
            <button
              type='button'
              className='tap-add-experience-2-btn-secondary cursor-pointer py-1 px-3 fs-7'
              onClick={() => handleSelectSuggestion(u)}
            >
              <span>Create</span>
            </button>
          </div>
        ))}
      </div>
    </div>
  )
}
